import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { CapacitorSafeService } from '../iframe-in-app/capacitor-safe.service';

@Injectable({
  providedIn: 'root'
})
export class AppPlatformService {

  constructor(private platform: Platform,
    private capacitorSafe: CapacitorSafeService,
  ) { }

  isAppPlatform(): boolean {
    return !this.capacitorSafe.isInIframe() &&  Capacitor.isNativePlatform() && ( Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android' );
  }

  isIosHibridApp(): boolean {
    return !this.capacitorSafe.isInIframe() && Capacitor.getPlatform() === 'ios';
  }

  isAndroidHibridApp(): boolean {
    return !this.capacitorSafe.isInIframe() && Capacitor.getPlatform() === 'android';
  }

  isMobileWeb(): boolean {
    return this.platform.is('mobileweb');
  }
}
